import Marquee from "react-fast-marquee";

const ITEMS = ["Municipal Expertise", "Professional Management", "Less Stress", "Billing Dispute Assistance", "Metering Solutions", "Account Management"];

export const EditorialMarquee = () => (
  <div className="bg-secondary py-5 overflow-hidden select-none">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8 font-heading text-lg md:text-xl font-medium uppercase tracking-[0.15em] text-white/95">
          {t}
          <span className="w-2 h-2 rotate-45 bg-white/80" />
        </span>
      ))}
    </Marquee>
  </div>
);
